// extracted by mini-css-extract-plugin
export default {"drawer":"WR","drawerheader":"XR","retake_quiz_bottom_bar":"YR","extra_drawer":"ZR","not_answered_questions":"aS","question_ui":"bS","accordion_details":"cS","retake_quiz":"eS","accordions":"fS","accordion_root":"gS","accordion_summary_text":"hS","animation":"iS","show_animation":"jS","overflow_hidden":"kS"};
    if(module.hot) {
      // 1715188238357
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  